import Link from 'next/link';
import Image from 'next/image';
import { EyeButton } from '@/components/footer/footerInfo/EyeButton/EyeButton';
import { PhoneLink } from '@/components/ui/PhoneLink/PhoneLink';
import { TextLink } from '@/components/ui/TextLink/TextLink';
import { SvgTg, SvgVk } from '@/components/icons';
import Logo from '@/assets/icons/logo-white.svg';
import { personal } from '@/constants/docs';
import { footerMenuItems } from './footerMenuItems';
import type { FooterInfoProps } from './footerInfo.types';
import s from './footerInfo.module.scss';
import { tgLink, vkLink } from '@/constants/socials';

const oooName = 'ООО «Клиника передовой медицины»'.toUpperCase();

export const FooterInfo = ({ aboutData }: FooterInfoProps) => {
  return (
    <>
      <div className={s.navWrapper}>
        <div className={`${s.logoBlock} ${s.leftSide}`}>
          <Link href="/" className={s.logo}>
            <Logo />
          </Link>
          <p className={s.location}>{aboutData.address}</p>
          <div className={s.socialLinks}>
            <p className={'txt-12-bold'}>присоединяйся к нам</p>
            <div className={s.socialIcons}>
              <a href={vkLink} target={'_blank'} rel={'noopener noreferrer'}><SvgVk /></a>
              <a href={tgLink} target={'_blank'} rel={'noopener noreferrer'}><SvgTg /></a>
            </div>
          </div>
        </div>
        <nav className={s.nav}>
          <ul className={s.menuGrid}>
            {footerMenuItems.map(menuItem => (
              <li key={menuItem.id} className={s.menuItem}>
                <Link href={menuItem.path}>{menuItem.title}</Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className={s.top}>
        <div className={s.leftSide}>
          <div className={s.assessment}>
            <div className={s.assessment__wrapper}>
              <Image
                src="/sign.png"
                alt="Эмблема Министерства здравоохранения Российской Федерации"
                width={49}
                height={53}
              />
              <div>
                <p className={s.assessment__text}>
                  Независимая оценка качества условий оказания услуг медицинскими организациями
                </p>
                <a
                  className={s.assessment__button}
                  href={'https://anketa.rosminzdrav.ru/staticogvjustank/30/1'}
                  target={'_blank'}
                  rel={'noreferrer'}
                >
                  Участвовать в голосовании
                </a>
              </div>
            </div>

            <div className={`${s.companyInfo} ${s.desktopOnly}`}>
              <div className={s.companyInfo__inner}>
                <p>{oooName}</p>
              </div>
              <div className={s.captions}>
                <p>Версия 1.0</p>
              </div>
            </div>
          </div>
        </div>

        <div className={s.textWrapper}>
          <div className={s.copyright}>
            <p>
              Все материалы данного сайта являются объектами авторского права. Запрещается копирование, распространение
              (в том числе путем копирования на другие сайты и ресурсы в Интернете) или любое иное использование
              информации и объектов без предварительного письменного согласия правообладателя. Указание ссылки на
              источник информации является обязательным.
            </p>
            <p>
              Администрация клиники принимает все меры по своевременному обновлению размещенного на сайте прайс-листа,
              однако во избежание возможных недоразумений, советуем уточнять стоимость услуг в регистратуре или в
              контакт-центре по телефону <PhoneLink phone={aboutData.main_phone} codeIsFour />. Размещенный прайс не
              является
              офертой. Медицинские услуги
              оказываются на основании договора.
            </p>

            <ul>
              <li>”ООО «Клиника передовой медицины»</li>
              <li>Юридический адрес: 355028, г. Ставрополь, Российский проспект, д. 11</li>
              <li>Фактический адрес: 355028, г. Ставрополь, Российский проспект, д. 11</li>
              <li>ИНН 2635264190 КПП 263501001 ОГРН 1252600000839</li>
            </ul>

            <ul>
              <li>Номер лицензии: Л041-01197-26/03280916</li>
              <li>Дата предоставления лицензии: 30.09.2025</li>
              <li>Лицензирующий орган: Министерство здравоохранения Ставропольского края</li>
            </ul>
          </div>

          <div className={`${s.captions} ${s.desktopOnly}`}>
            <div className={s.captions__wrapper}>
              <EyeButton className={s.eyeglasses} />
              <p>
                <TextLink
                  text={'Контакты контролирующих органов'}
                  href={'/contacts.pdf'}
                  target={'_blank'}
                />
              </p>
              <p>
                <TextLink text={'Политика обработки персональных данных'} href={personal} target={'_blank'} />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className={s.bottom}>
        <div>
          <p>{oooName}</p>
          <p>{aboutData.address}</p>
        </div>
        <div>
          <EyeButton className={s.eyeglasses} />
          <p>
            <TextLink
              text={'Контакты контролирующих органов'}
              href={'/contacts.pdf'}
              target={'_blank'}
            />
          </p>
          <p>
            <TextLink text={'Политика обработки персональных данных'} href={personal} target={'_blank'} />
          </p>
        </div>
      </div>
    </>
  );
};